import { engineComponent } from "neo-common";
import { Controller } from "../Controller";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { PickModel } from "./PickModel";
import { PickView } from "./PickView";

@engineComponent(ComponentTypes.Controller)
export class PickController extends Controller {
    public static readonly StartReceived: string = "eventStartReceived";
    public static readonly SelectReceived: string = "eventSelectReceived";
    public static readonly EndReceived: string = "eventEndReceived";
    public static readonly UpdateCounters: string = "eventUpdateCounters";
    public static readonly UpdateCountersValues: string = "eventUpdateCountersValues";
    public static readonly SelectComplete: string = "eventSelectComplete";
    public static readonly IntroFinished: string = "eventIntroFinished";
    public static readonly OutroFinished: string = "eventOutroFinished";

    protected _view: PickView;
    protected _model: PickModel;

    constructor() {
        super();
    }

    startInitialization(view: any): void {
        if (DEBUG) {
            this.log("startInitialization");
        }

        if (view instanceof PickView) {
            this._view = view;
        } else {
            if (DEBUG) {
                this.log("ERROR view is not instance of PickView");
            }
        }

        this._model = new PickModel(this);
    }

    initReceived(): void {
        this._view.initReceived(this);
    }

    disableLogo(): void {
        this._view.disableLogo();
    }

    initIntro(): void {
        this._view.initIntro();
    }

    collect(): void {}

    start(): void {
        this._model.start();
        this._view.start();
    }

    select(id: number): void {
        this._model.select(id);
    }

    end(): void {
        this._model.end();
        this._view.end();
    }

    startReceived(): void {
        this._view.startReceived();
        this.emit(PickController.StartReceived);
    }

    selectReceived(): void {
        this._view.selectReceived();
        this.emit(PickController.SelectReceived);
    }

    endReceived(): void {
        this._view.endReceived();
        this.emit(PickController.EndReceived);
    }

    updateCounters(): void {
        this.emit(PickController.UpdateCounters);
    }

    updateCountersValues(): void {
        this.emit(PickController.UpdateCountersValues);
    }

    selectComplete(): void {
        this.emit(PickController.SelectComplete);
    }

    intro(long: boolean = false): void {
        this._view.intro(long);
    }

    introFinished(): void {
        this.emit(PickController.IntroFinished);
    }

    outro(): void {
        this._view.outro();
    }

    outroFinished(): void {
        this.emit(PickController.OutroFinished);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Pick/PickController.ts
 **/